import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/Home"),
      children: [
        {
          path: "",
          name: "home",
          component: () => import("@/views/HomeGlobal")
        },
        {
          path: "my-feed",
          name: "home-my-feed",
          component: () => import("@/views/HomeMyFeed")
        },
        {
          path: "tag/:tag",
          name: "home-tag",
          component: () => import("@/views/HomeTag")
        }
      ]
    },
    {
      name: "emailValidationSuccess",
      path: "/email-validation/success",
      component: () => import("@/views/EmailValidationSuccess")
    },
    {
      name: "emailValidation",
      path: "/email-validation",
      component: () => import("@/views/EmailValidation")
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/Login")
    },
    {
      name: "register",
      path: "/register",
      component: () => import("@/views/Register")
    },
    {
      name: "registerConfirm",
      path: "/register/confirm",
      component: () => import("@/views/RegisterConfirm")
    },
    {
      name: "registerThanks",
      path: "/register-thanks",
      component: () => import("@/views/RegisterThanks")
    },
    {
      name: "settings",
      path: "/settings",
      component: () => import("@/views/Settings")
    },
    // Handle child routes with a default, by giving the name to the
    // child.
    // SO: https://github.com/vuejs/vue-router/issues/777
    {
      path: "/@:username",
      component: () => import("@/views/Profile"),
      children: [
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/views/ProfileArticles")
        },
        {
          name: "profile-favorites",
          path: "favorites",
          component: () => import("@/views/ProfileFavorited")
        }
      ]
    },
    {
      name: "orderList",
      path: "/order-list",
      component: () => import("@/views/OrderList")
    },
    {
      name: "profileEdit",
      path: "/profile/edit",
      props: true,
      component: () => import("@/views/ProfileEdit")
    },
    {
      name: "profileEditConfirm",
      path: "/profile/edit-confirm",
      props: true,
      component: () => import("@/views/ProfileEditConfirm")
    },
    {
      name: "article",
      path: "/articles/:slug",
      component: () => import("@/views/Article"),
      props: true
    },
    {
      name: "article-edit",
      path: "/editor/:slug?",
      props: true,
      component: () => import("@/views/ArticleEdit")
    },
    {
      name: "order",
      path: "/order",
      props: true,
      component: () => import("@/views/Order")
    },
    {
      name: "order-confirm",
      path: "/order-confirm",
      props: true,
      component: () => import("@/views/OrderConfirm")
    },
    {
      name: "tds-auth-confirm",
      path: "/tds-auth-confirm",
      props: true,
      component: () => import("@/views/TdsAuthConfirm")
    },
    {
      name: "order-thanks",
      path: "/order-thanks",
      props: true,
      component: () => import("@/views/OrderThanks")
    },
    {
      name: "history",
      path: "/order/list",
      props: true,
      component: () => import("@/views/History")
    },
    {
      name: "cart",
      path: "/cart",
      props: true,
      component: () => import("@/views/Cart")
    },
    {
      name: "noodles",
      path: "/noodles",
      props: true,
      component: () => import("@/views/Noodles")
    },
    {
      name: "noodlesDetail",
      path: "/noodles/:id",
      props: true,
      component: () => import("@/views/NoodlesDetail")
    },
    {
      name: "withdrawal1",
      path: "/withdrawal1",
      props: true,
      component: () => import("@/views/Withdrawal1")
    },
    {
      name: "withdrawal2",
      path: "/withdrawal2",
      props: true,
      component: () => import("@/views/Withdrawal2")
    },
    {
      name: "withdrawal3",
      path: "/withdrawal3",
      props: true,
      component: () => import("@/views/Withdrawal3")
    },
    {
      name: "favorite",
      path: "/favorite",
      props: true,
      component: () => import("@/views/Favorite")
    },
    {
      name: "goods",
      path: "/goods/:id",
      props: true,
      component: () => import("@/views/Goods")
    },
    {
      name: "forgot",
      path: "/forgot",
      props: true,
      component: () => import("@/views/ForgotMail")
    },
    {
      name: "forgotSent",
      path: "/forgot/sent",
      props: true,
      component: () => import("@/views/ForgotSent")
    },
    {
      name: "resetPassword",
      path: "/password/reset",
      props: true,
      component: () => import("@/views/ResetPassword")
    },
    {
      name: "resetPasswordComplete",
      path: "/password/reset/complete",
      props: true,
      component: () => import("@/views/ResetPasswordComplete")
    },
    {
      name: "logout",
      path: "",
      props: true,
      component: () => import("@/views/Logout")
    },
    {
      name: "guide",
      path: "/guide",
      props: true,
      component: () => import("@/views/Guide")
    },
    {
      name: "goodsList",
      path: "/goods-list",
      props: true,
      component: () => import("@/views/GoodsList")
    },
    {
      name: "tokushoho",
      path: "/tokushoho",
      props: true,
      component: () => import("@/views/Tokushoho")
    },
    {
      name: "faq",
      path: "/faq",
      props: true,
      component: () => import("@/views/Faq")
    },
    {
      path: "/:pathMatch(.*)",
      component: () => import("@/views/Home")
    }
  ],
  scrollBehavior() {
    document.getElementById("app").scrollIntoView();
  }
});
